import React, {
  FunctionComponent,
  ReactElement,
  ReactNode,
  useEffect,
  useState,
} from 'react';
import { School, UserInfo, YearSem } from '../model';
import Apis from '../apis';
import { ErrorDispatches } from '../redux/Dispatches';
import {
  AuthedLayout,
  EditableTableDiv,
  HeaderDisplayKeysWithType,
} from '../components';
import { connect, ConnectedProps } from 'react-redux';
import { Button, Row } from 'react-bootstrap';
import { I18N } from '../i18n-raw';
import { ApplicationState } from '../redux/States';
import { DateTime } from 'luxon';
import { toast } from 'react-toastify';

const mapState = (app: ApplicationState) => ({ ...app.auth });
const mapDispatch = { ...ErrorDispatches };
const connector = connect(mapState, mapDispatch);
type Prop = ConnectedProps<typeof connector>;

type TransformSchoolProperty = {
  name: string;
  value?: ReactNode;
  code: string;
};

function transformSchoolObj(
  school: School | undefined,
  user: UserInfo | undefined,
  currentSchoolYear: YearSem,
  extraExportNode?: ReactNode
): TransformSchoolProperty[] {
  const now = DateTime.now();
  // let content = <></>;
  // if (now.month === 7 && currentSchoolYear.sem === 2) {
  //   content = (
  //     <Button
  //       onClick={() => {
  //         Apis.promoteSemester()
  //           .then(() => {
  //             window.location.reload();
  //           })
  //           .catch((err) => {
  //             console.error(err);
  //             alert('學期轉換失敗，請稍後再試。');
  //           });
  //       }}
  //     >
  //       提前進行學期轉換
  //     </Button>
  //   );
  // } else if (now.month === 7 && currentSchoolYear.sem === 1) {
  //   content = <span className="text-success"> (已進行學期轉換) </span>;
  // }
  return [
    {
      code: 'SchoolName',
      name: '學校名稱',
      value: school?.name,
    },
    {
      code: 'SchoolId',
      name: '學校代號',
      value: school?.id,
    },
    {
      code: 'NurseName',
      name: '健康中心聯絡人',
      value: user?.name,
    },
    {
      code: 'SchoolTel',
      name: '電話',
      value: school?.tel,
    },
    {
      code: 'SchoolAddress',
      name: '地址',
      value: school?.address,
    },
    {
      code: 'SchoolRank',
      name: '學制',
      value: I18N.SchoolRanks[school?.rank || 0] ?? '',
    },
    { code: 'ExportFileType', name: '文件輸出格式', value: extraExportNode },
    // {
    //   code: 'CurrentSemester',
    //   name: '目前學年',
    //   value: (
    //     <>
    //       {school?.currentSchoolYear} {content}
    //     </>
    //   ),
    // },
  ];
}

const headerDisplayKeys: HeaderDisplayKeysWithType<TransformSchoolProperty>[] =
  [
    { display: '代號', property: 'code', style: { width: '30%' } },
    { display: '項目', property: 'name', style: { width: '20%' } },
    { display: '内容', property: 'value', style: { width: '50%' } },
  ];

const schoolInfo: FunctionComponent<Prop> = ({
  user: authUser,
  catchErrorForModal,
}) => {
  const [school, setSchool] = useState<School>();
  const [user, setUser] = useState<UserInfo>();
  const [editingExport, setEditingExport] = useState(false);
  const [tempExportType, setTempExportType] = useState<number>(user?.exportFileType ?? 0);
  const exportLabel = (n: number) => (n === 1 ? 'ODF' : 'Excel');
  useEffect(() => {
    Apis.getCurrentSchool()
      .then((school) => {
        setSchool(school);
      })
      .catch(catchErrorForModal);
    Apis.getUserInfo()
      .then((u) => {
        setUser(u);
        setTempExportType(u.exportFileType)
      })
      .catch(catchErrorForModal);
  }, []);
  async function onUpdateExportExcel() {
    toast
      .promise(Apis.updateFileType(tempExportType), {
        pending: '資料上傳中......',
        success: '上傳成功！',
        error: '上傳失敗！請查看錯誤資訊。',
      })
      .then(() => {
        setEditingExport(false);
      })
      .catch(catchErrorForModal);
  }
  if (!authUser) {
    return <></>;
  }
  const exportTypeNode = !editingExport ? (
    <>
      <span className="mr-3">{exportLabel(tempExportType)}</span>
      <Button size="sm" variant="outline-primary" onClick={() => setEditingExport(true)}>
        修改
      </Button>
    </>
  ) : (
    <div>
      <div className="form-check form-check-inline">
        <input
          className="form-check-input"
          type="radio"
          id="exportExcel"
          name="exportType"
          checked={tempExportType === 0}
          onChange={() => setTempExportType(0)}
        />
        <label className="form-check-label" htmlFor="exportExcel">Excel</label>
      </div>
      <div className="form-check form-check-inline">
        <input
          className="form-check-input"
          type="radio"
          id="exportODF"
          name="exportType"
          checked={tempExportType === 1}
          onChange={() => setTempExportType(1)}
        />
        <label className="form-check-label" htmlFor="exportODF">ODF</label>
      </div>
      <div className="mt-2">
        <Button
          size="sm"
          className="mr-2"
          onClick={onUpdateExportExcel}
        >
          儲存
        </Button>
        <Button
          size="sm"
          variant="outline-secondary"
          onClick={() => {
            setTempExportType(user?.exportFileType ?? 0);
            setEditingExport(false);
          }}
        >
          取消
        </Button>
      </div>
    </div>
  );
  const transformedSchool = transformSchoolObj(
    school,
    user,
    authUser.semesters[authUser.currentSemester],
    exportTypeNode
  );
  return (
    <AuthedLayout>
      <Row>
        <EditableTableDiv
          headers={headerDisplayKeys}
          values={transformedSchool}
        />
      </Row>
    </AuthedLayout>
  );
};

export const SchoolInfo = connector(schoolInfo);
